import { render, staticRenderFns } from "./BadgeValueSetting.vue?vue&type=template&id=74f64654&scoped=true"
import script from "./BadgeValueSetting.vue?vue&type=script&lang=js"
export * from "./BadgeValueSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f64654",
  null
  
)

export default component.exports